import React from 'react';
import Loader from '../../../Components/Widgets/Loader/generic';

export default function LoaderOrError({ loading, error }: { loading: boolean; error: unknown; }) {
  if (loading) return <Loader />;
  if (error)   return <div className="text-danger">Errore: {(error as Error)?.message ?? String(error)}</div>;
  return null;
}
